module.exports = __webpack_public_path__ + "static/img/WeChatLogo.0e0c435f.png";